import React, { useState } from 'react';
import TextField from '@material-ui/core/TextField';

import t from './common/localization';
import EditItemView from './EditItemView';
import vendorsAttributes from './attributes/vendorsAttributes';
import { Accordion, AccordionSummary, AccordionDetails, makeStyles, Typography, FormControlLabel, Checkbox,
 Paper } from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import EditAttributesView from './attributes/EditAttributesView';
import deviceAttributes from './attributes/deviceAttributes';
import { deviceCategories } from './common/deviceCategories';
import LinkField from './form/LinkField';
import { prefixString } from './common/stringUtils';
import Grid from '@material-ui/core/Grid';
import Styles from '@material-ui/core/styles';
import FormControl from "@material-ui/core/FormControl";

const useStyles = makeStyles(() => ({
  details: {
    flexDirection: 'flex',
  },
  textField: {
               margin: '4px',
               width: '85%',
    },
   root: {
               padding: '10px',
               margin: '10px',
               marginLeft: '60px',
   },
}));

const BladePage = () => {
  const classes = useStyles();

  const [item, setItem] = useState();

  return (
    <EditItemView endpoint="blades" item={item} setItem={setItem}>
      {item &&
        <>
     <div className={classes.root}>
     <Grid container spacing={3}>
       <Grid item xs={8}>
         <Paper elevation={3} >
         <Accordion defaultExpanded>
           <AccordionSummary expandIcon={<ExpandMoreIcon />}>
             <Typography variant="subtitle1">
              {t('sharedRequired')}
             </Typography>
           </AccordionSummary>
           <AccordionDetails className={classes.details}>
           <Grid container spacing={3}>
           <Grid item xs={6}>
                        <TextField className={classes.textField}
                                    margin="normal"
                                    InputProps={{ disableUnderline: true }}
                                    value={item.name || ''}
                                    onChange={event => setItem({...item, name: event.target.value})}
                                    label={t('sharedName')}
                                    variant="standard" />
                                    </Grid>
             <Grid item xs={6}>
             <TextField className={classes.textField}
                         margin="normal"
                         InputProps={{ disableUnderline: true }}
                         value={item.packageId || ''}
                         onChange={event => setItem({...item, packageId: event.target.value})}
                         label={t('sharedPackageId')}
                         variant="standard" />
                         </Grid>
          <Grid item xs={6}>
             <TextField className={classes.textField}
                         margin="normal"
                         InputProps={{ disableUnderline: true }}
                         value={item.newPackageId || ''}
                         onChange={event => setItem({...item, newPackageId: event.target.value})}
                         label={t('sharedNewPackageId')}
                         variant="standard" />
                         </Grid>

           <Grid item xs={6}>
             <TextField className={classes.textField}
                         margin="normal"
                         InputProps={{ disableUnderline: true }}
                         value={item.type || ''}
                         onChange={event => setItem({...item, type: event.target.value})}
                         label={t('bladeTypes')}
                         variant="standard" />
                         </Grid>
                <Grid item xs={6}>
               <TextField className={classes.textField}
                margin="normal"
                InputProps={{ disableUnderline: true }}
                value={item.link || ''}
                onChange={event => setItem({...item, link: event.target.value})}
                label={t('sharedLink')}
                variant="standard" />
                </Grid>
                 <Grid item xs={6}>
                  <TextField className={classes.textField}
                  margin="normal"
                                                         InputProps={{ disableUnderline: true }}
                                                         value={item.accountEmail || ''}
                                                         onChange={event => setItem({...item, accountEmail: event.target.value})}
                                                         label={t('accountEmail')}
                                                         variant="standard" />
                                                         </Grid>

                                                        <Grid item xs={6}>
                                                        <TextField className={classes.textField}
                                                         margin="normal"
                                                         InputProps={{ disableUnderline: true }}
                                                         value={item.password || ''}
                                                         onChange={event => setItem({...item, password: event.target.value})}
                                                         label={t('userPassword')}
                                                         variant="standard" />
                                                         </Grid>
                                                         <Grid item xs={6}>
                                                        <TextField className={classes.textField}
                                                         margin="normal"
                                                         InputProps={{ disableUnderline: true }}
                                                         value={item.fcmServerKey || ''}
                                                         onChange={event => setItem({...item, fcmServerKey: event.target.value})}
                                                         label={t('fcmServerKey')}
                                                         variant="standard" />
                                                         </Grid>
                                                          <Grid item xs={6}>
                                                                                                                 <TextField className={classes.textField}
                                                                                                                  margin="normal"
                                                                                                                  InputProps={{ disableUnderline: true }}
                                                                                                                  value={item.fcmServiceAccountKey || ''}
                                                                                                                  onChange={event => setItem({...item, fcmServiceAccountKey: event.target.value})}
                                                                                                                  label={t('fcmServiceKey')}
                                                                                                                  variant="standard" />
                                                                                                                  </Grid>
                                                         <Grid item xs={6}>
                                                        <TextField className={classes.textField}
                                                         margin="normal"
                                                         InputProps={{ disableUnderline: true }}
                                                         value={item.contact || ''}
                                                         onChange={event => setItem({...item, contact: event.target.value})}
                                                         label={t('devicesContact')}
                                                         variant="standard" />
                                                         </Grid>
                                                         <Grid item xs={6}>
                                                        <TextField className={classes.textField}
                                                        type="number"
                                                         margin="normal"
                                                         InputProps={{ disableUnderline: true }}
                                                         value={item.minVersion || ''}
                                                         onChange={event => setItem({...item, minVersion: event.target.value})}
                                                         label={t('minVersion')}
                                                         variant="standard" />
                                                         </Grid>

                                                         <Grid item xs={6}>
                                                        <TextField className={classes.textField}
                                                        type="number"
                                                         margin="normal"
                                                         InputProps={{ disableUnderline: true }}
                                                         value={item.currentVersion || ''}
                                                         onChange={event => setItem({...item, currentVersion: event.target.value})}
                                                         label={t('currentVersion')}
                                                         variant="standard" />
                                                         </Grid>

                                                         <Grid item xs={6}>
                                                        <TextField className={classes.textField}
                                                         margin="normal"
                                                         InputProps={{ disableUnderline: true }}
                                                         value={item.updateFeatures || ''}
                                                         onChange={event => setItem({...item, updateFeatures: event.target.value})}
                                                         label={t('updateFeatures')}
                                                         variant="standard" />
                                                         </Grid>
                                                         <Grid item xs={6}>
                                                          <FormControlLabel
                                                          control={
                                                          <Checkbox
                                                          color="primary"
                                                          checked={item.disabled}
                                                          onChange={event => setItem({...item, disabled: event.target.checked})}
                                                          />
                                                          }
                                                         label={t('sharedDisabled')} />
                                                        </Grid>
                                                         <Grid item xs={6}>
                                                          <FormControlLabel
                                                           control={
                                                           <Checkbox
                                                           color="primary"
                                                           checked={item.updatePush}
                                                           onChange={event => setItem({...item, updatePush: event.target.checked})}
                                                            />
                                                            }
                                                            label={t('updatePush')} />
                                                            </Grid>
                                                         </Grid>
             </AccordionDetails>
            </Accordion>
            </Paper>
            </Grid>
         <Grid item xs={4}>
         <Paper elevation={3} >
             <Accordion defaultExpanded>
             <AccordionSummary expandIcon={<ExpandMoreIcon />}>
              <Typography variant="subtitle1">
                {t('sharedAttributes')}
              </Typography>
             </AccordionSummary>
             <AccordionDetails className={classes.details}>
                           <EditAttributesView
                             attributes={item.attributes}
                             setAttributes={attributes => setItem({...item, attributes})}
                             definitions={vendorsAttributes}
                             />
         </AccordionDetails>
         </Accordion>
         </Paper>
         </Grid>
         </Grid>
        </div>
        </>
      }
    </EditItemView>
  );
}

export default BladePage;
